var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-home"},[_c('van-row',{staticClass:"banner"},[_c('van-col',{attrs:{"span":"24"}},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/images/points_gift.png")}})])],1),_c('van-row',[_c('van-col',{attrs:{"span":"24"}},[_c('points-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }